import * as R from 'ramda';
import * as RA from 'ramda-adjunct';

export const sum = R.sum;

export const concat = R.concat;

export const ensureArray = RA.ensureArray;
